export default __webpack_public_path__ + "static/media/SCSS.c5213e47.png";